import {DatePipe} from "@angular/common"
import {ChangeDetectionStrategy, Component, inject} from "@angular/core"
import {TIPPY_REF} from "@ngneat/helipopper"
import {TippyInstance} from "@ngneat/helipopper/config"
import {CascadeStep, CATEGORY_CLASS, PLATFORM, STATUS, stepShortLabel} from "@platform/components/jobs/job-task-cascade/job-task-cascade.model"

/**
 * The hover card for one cascade step: the group, its mode + cost tier and status, then the step's events
 * as a vertical list (a coloured dot per category, label, time, message). Shown via Tippy — the step is
 * handed in through {@link TIPPY_REF}.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-job-task-cascade-popover",
    templateUrl: "./job-task-cascade-popover.component.html",
    styleUrls: ["./job-task-cascade-popover.component.scss"],
    imports: [DatePipe],
})
export class JobTaskCascadePopoverComponent {
    readonly step = inject<TippyInstance>(TIPPY_REF).data as CascadeStep

    readonly name = stepShortLabel(this.step)
    readonly platform = PLATFORM[this.step.platform]
    readonly status = STATUS[this.step.status]

    categoryClass(category: CascadeStep["events"][number]["category"]): string {
        return CATEGORY_CLASS[category]
    }
}
